// extracted by mini-css-extract-plugin
export default {"docs-link":"jqSS","docsLink":"jqSS","icon":"TUTT"};